





















































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import GroupBuyDetail from "./groupBuy-detail.vue";
import Ajax from "../../lib/ajax";
import GroupBuyRecords from "./groupBuyRecord.vue";
import groupBuy from "@/store/entities/groupBuy";

class PagegroupBuyRequest extends PageRequest {
  status: null;
  courtId: null;
  canMakePriceDiff: boolean | number | string | any;
}

@Component({
  components: { GroupBuyDetail, GroupBuyRecords },
})
export default class groupBuys extends AbpBase {
  // 编辑按钮事件处理
  edit() {
    this.editModalShow = true;
  }

  //请求过滤参数
  pagerequest: PagegroupBuyRequest = new PagegroupBuyRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  groupBuyId: number = null;
  courtList: Array<any> = [];
  groupBuyShow: boolean = false;
  groupBuy: groupBuy = new groupBuy();
  editIndex: number = -1;
  price: number | null = null;
  maxPerson: number | null = null;
  minPerson: number | null = null;
  updateShow: boolean = false;
  isSetPriceDiff: boolean = false;
  priceDiff: number | null = null;
  groupBuyList: Array<any> = [
    {
      value: 1,
      label: "是",
    },
    {
      value: 0,
      label: "否",
    },
  ];
  statusList: Array<any> = [
    {
      value: 0,
      label: "待确认价格",
    },
    {
      value: 1,
      label: "取消开团",
    },
    {
      value: 2,
      label: "拼团中",
    },
    {
      value: 3,
      label: "拼团失败",
    },
    {
      value: 4,
      label: "拼团成功",
    },
    {
      value: 5,
      label: "待补差价",
    },
  ];
  /**
   * @description:打开记录弹窗
   */
  openRecordModal(id) {
    this.groupBuyId = id;
    this.groupBuyShow = true;
  }
  /**
   * @description:事件
   */
  menuClick(name, row, index) {
    switch (name) {
      case "record":
        this.openRecordModal(row.id);
        break;
      case "cancel":
        this.editIndex = -1;
        break;
      case "detail":
        this.groupBuy = row;
        this.createModalShow = true;
        break;
      case "updatePerson":
        this.changeIndex(row.id, index, this.price);
        break;
      case "setPriceDiff":
        this.setPriceDiff(row.id);
      default:
        break;
    }
  }
  /**
   * @description:补差价
   */
  async setPriceDiff(id) {
    if (this.priceDiff) {
      let data = {
        groupBuyId: id,
        price: this.priceDiff,
      };
      await this.$store.dispatch({
        type: "groupBuy/setPriceDiff",
        data: data,
      });
      this.isSetPriceDiff = false;
      this.getpage();
      return;
    }
    this.isSetPriceDiff = true;
  }
  async changeIndex(id, index, price) {
    if (this.editIndex == -1) {
      this.editIndex = index;
    } else {
      //调用接口
      if (price) {
        this.price = price;
      }
      if (!this.price) {
        this.$Message.error({
          content: "请输入价格",
        });
        return;
      }
      if (!this.minPerson) {
        this.$Message.error({
          content: "请输入最小人数",
        });
        return;
      }
      if (!this.minPerson) {
        this.$Message.error({
          content: "请输入最大人数",
        });
        return;
      }
      if (!/^\d+$/.test(this.minPerson.toString())) {
        this.$Message.error({
          content: "最小人数必须是整数",
        });
        return;
      }
      if (!/^\d+$/.test(this.maxPerson.toString())) {
        this.$Message.error({
          content: "最大人数必须是整数",
        });
        return;
      }
    if (isNaN(this.price)) {
        this.$Message.error({
          content: "价格必须是数字",
        });
        return;
      }
      const data = {
        price: this.price,
        groupBuyId: id,
        minPerson: this.minPerson,
        maxPerson: this.maxPerson,
      };
      await this.$store.dispatch({
        type: "groupBuy/confirmPrice",
        data: data,
      });
      this.editIndex = -1;
      this.$Message.success({
        content: "修改成功",
      });
      this.getpage();
    }
  }
  get list() {
    return this.$store.state.groupBuy.list;
  }

  get loading() {
    return this.$store.state.groupBuy.loading;
  }
  create() {
    this.createModalShow = true;
  }
  pageChange(page: number) {
    this.$store.commit("groupBuy/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("groupBuy/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("groupBuy/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "groupBuy/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.groupBuy.pageSize;
  }
  get totalCount() {
    return this.$store.state.groupBuy.totalCount;
  }
  get currentPage() {
    return this.$store.state.groupBuy.currentPage;
  }
  //  get orderStatesDic() {
  //     return this.$store.state.common.orderStatesDic;
  //   }
  async delGroupBuy(id) {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: "确定要删除团购吗",
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        const data = {
          id: id,
        };
        await this.$store.dispatch({
          type: "groupBuy/delete",
          data: data,
        });
        await this.getpage();
      },
    });
  }
  async getCourtList() {
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames");
    this.courtList = reponse.data.result;
  }
  async created() {
    this.getCourtList();
    this.getpage();
  }
  columns = [
    {
      title: "团名称",
      key: "groupBuyName",
      tooltip: true,
      width: 200,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.groupBuyName ? params.row.groupBuyName : "暂无"
        );
      },
    },
    {
      title: "开团人姓名",
      key: "fullName",
    },
    {
      title: "球场名称",
      width: 200,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.court.name ? params.row.court.name : "暂无"
        );
      },
    },
    {
      title: "最小人数",
      key: "minPerson",
      slot: "minPerson",
    },
    {
      title: "最大人数",
      key: "maxPerson",
      slot: "maxPerson",
    },
    {
      title: "价格",
      key: "price",
      slot: "price",
    },
    {
      title: "差价",
      key: "priceDiff",
      slot: "pricediff",
    },
    {
      title: "需要人数",
      render: (h: any, params: any) => {
        return h("span", params.row.needNumber);
      },
    },
    {
      title: "当前人数",
      key: "currentNumber",
    },

    {
      title: "拼团状态",
      render: (h: any, params: any) => {
        return h("span", this.statusList[params.row.status].label);
      },
    },
    // {
    //   title: "订单状态",
    //   width: 80,
    //   slot: "orderState",

    //   render: (h: any, params: any) => {
    //     return h("span",this.orderStatesDic[params.row.orderState] );
    //   },
    // },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      width: 120,
      render: (h: any, params: any) => {
        return h("span", new Date(params.row.creationTime).toLocaleString());
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 200,
      slot: "action",
    },
  ];
}
